import * as React from 'react';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

type ProjectLeftPanelInfoIconProps = {
    children: ReactChildrenGeneralType
}
function ProjectLeftPanelInfoIcon({ children }: ProjectLeftPanelInfoIconProps) {
    return (
        <div className="ProjectLeftPanel__info-icon">
            {children}
        </div>
    );
}

export default ProjectLeftPanelInfoIcon;
